module.exports = __webpack_public_path__ + "img/xiaoman4.3d699e70.png";